export const projectsText = "PROJECTS";
export const projects = [{
    name: "Conformal Antenna designing using Computer Simulation Technology Software( B.Tech Final Year Project)",
    description: "Conformal antennas are a type of phased array antenna and it’s purpose is to embedded the antennas on curved surfaces. These antennas can easily be embedded on our regular shapes and objects."
}, {
    name: "WeatherApp",
    link: "https://harshavardhan1.github.io/WeatherApp/",
    description: "A Weather Application where we can know details of weather in specific area"
}, {
    name: "Calculator App With React Native",
    link: "https://github.com/harshavardhan1/Calculator-App-with-React-Native",
    description: "A Calculator Application where we can do some basic calculations like Addition, Subraction, Mutliplication, Division, Remainder"
}];

export const copyLink="Copy Link";
export const linkCopied='Link Copied';
export const openInTab='Open In New Tab';
export const showQr='Show QRCode';